import { render, staticRenderFns } from "./PasswordExpired.vue?vue&type=template&id=7e23e027&scoped=true&"
import script from "./PasswordExpired.vue?vue&type=script&lang=js&"
export * from "./PasswordExpired.vue?vue&type=script&lang=js&"
import style0 from "./PasswordExpired.vue?vue&type=style&index=0&id=7e23e027&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e23e027",
  null
  
)

export default component.exports